import {Link} from "react-router";

import {ServiceUsage} from "@/lib/types/checks.ts";

interface InstantCheckoutPurchaseFailureProps {
  serviceUsage: ServiceUsage;
}

export const InstantCheckoutPurchaseFailure = ({serviceUsage}: InstantCheckoutPurchaseFailureProps) => (
  <small>
    <p>
      The transaction was <strong>unsuccessful</strong>. You can find the reason for transaction failure on the{" "}
      <Link to="/billing/history" target="_blank">
        Invoices page
      </Link>{" "}
      within next 2 hours.
    </p>
    <p>
      You have reached the maximum number of <strong>{serviceUsage.limit_name}</strong> Checks available in your
      account.
    </p>
    <p>
      If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
    </p>
  </small>
);
